import React from 'react'
import PropTypes from 'prop-types'
import CheckBox from '../../CheckBox/CheckBox'

const AddressLine = ({ address, id, label, onChange, checked, value }) => {
    return (
        <div className="w-full h-auto flex flex-row items-center justify-start border-b border-gray-200">
            <CheckBox
                defaultChecked={checked}
                onChange={() => onChange({ address, id, label, value })}
                size="small"
            />

            <div className="my-2 ml-2 flex flex-grow flex-col items-start justify-start h-auto">
                <p className="text-gray-900 text-sm font-normal">{label}</p>
                <p className="text-gray-500 text-xs font-normal">{address}</p>
            </div>
        </div>
    )
}

AddressLine.propTypes = {
    address: PropTypes.string,
    id: PropTypes.number,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
}

export default AddressLine
